import { Modal } from '@servicetitan/design-system';

export const ACHLearnMoreModal = (props: { onClose(): void }) => {
    return (
        <Modal
            open
            closable
            size={Modal.Sizes.S}
            onClose={props.onClose}
            title="Connect with Routing and Account Numbers"
        >
            <div>
                <p>
                    You can connect to your bank by manually entering the routing and account
                    numbers instead of logging in.
                </p>
                <p>
                    <ol>
                        <li>Click ‘Connect Your Bank’.</li>
                        <li>Follow the prompts until you reach the Select Your Bank screen.</li>
                        <li>
                            Type “zzz” into the search bar, and then click ‘Link with account
                            numbers’.
                        </li>
                        <li>
                            Select your account type and enter your bank's routing and account
                            numbers.
                        </li>
                    </ol>
                </p>
                <p>
                    Once you connect, we'll make 2 small deposits to your bank account that you'll
                    need to verify within 48 hours.
                </p>
            </div>
        </Modal>
    );
};
